import React from 'react';
import SentenceComponent from 'projects/components/SentenceComponent';

var paragraphStyle = {
    lineHeight: "31px"
};

const SentencesComponent = ({
    sentences,
    paragraphHover,
    isPrint,
    enableHover = false,
    hasEditPermission,
    onHoverExcerpt,
    hoverExcerptId,
    primeCode
 }) => {
    const sentencesComponents = sentences.map((sentence, index) =>
        <SentenceComponent key={index}
                            codedSentence={sentence}
                            paragraphHover={paragraphHover}
                            index={index}
                            isPrint={isPrint}
                            enableHover={enableHover}
                            hasEditPermission={hasEditPermission}
                            onHover={onHoverExcerpt}
                            hoverExcerptId={hoverExcerptId}
                            primeCodeId={primeCode}
                            />
    );

    return (
        <p style={paragraphStyle}>
            {sentencesComponents}
        </p>
    )
}

export default SentencesComponent;